var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCaretDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "10 12 10 6"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M19.85 13.537a.465.465 0 0 0 0-.684l-.716-.684a.52.52 0 0 0-.714 0l-3.405 3.295-3.433-3.322a.52.52 0 0 0-.717 0l-.717.684a.47.47 0 0 0 0 .683l4.508 4.35a.526.526 0 0 0 .717 0z"
})));
export default SvgCaretDown;